import {
  Tooltip as MUITooltip,
  TooltipProps,
  ClickAwayListener,
} from '@mui/material';
import { useState, cloneElement, FC } from 'react';

import { useStyles } from './Tooltip.styles';
/**
 * A click-event Tooltip component that takes all props from MUI's TooltipProps.
 */
export const Tooltip: FC<TooltipProps> = ({ children, ...props }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const clonedChildren = cloneElement(children, {
    onClick: () => setOpen(!open),
  });

  const close = () => setOpen(false);

  return (
    <ClickAwayListener onClickAway={close}>
      <MUITooltip
        disableHoverListener
        disableTouchListener
        disableFocusListener
        onClose={close}
        open={open}
        arrow
        classes={classes}
        {...props}
      >
        {clonedChildren}
      </MUITooltip>
    </ClickAwayListener>
  );
};
